import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/kenteken',
    name: 'kenteken',
    component: HomeView,
    props: true
  },
  {
    path: '/kenteken/:kentekennum',
    name: 'viewKenteken',
    component: () => import(/* webpackChunkName: "kenteken" */ '../views/KentekenView.vue'),
    props: true
  },
  {
    path: '/privacy-cookies',
    name: 'Privacy en Cookies',
    component: () => import(/* webpackChunkName: "Privacy" */ '../views/PrivacyCookies.vue'),
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "Notfound" */ '../views/NotFound.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
